import React, { createContext, useContext, useState, useEffect, useMemo } from "react";

const translations = {
  ro: {
    nav: {
      home: "Acasă",
      about: "Despre noi",
      pricing: "Prețuri",
      docs: "Acte necesare",
      gallery: "Galerie",
      faq: "Întrebări - FAQ",
      faqFull: "Întrebări frecvente - FAQ",
      contact: "Contact",
      book: "Programare",
      callNow: "Sună acum",
    },
    hero: {
      eyebrow: "Școală de șoferi · Categoria B",
      title1: "Învață să conduci",
      title2: "în liniște și siguranță",
      subtitle: "BIU BIU DRIVING – Școala ta de șoferi categoria B, cutie manuală și automată, în Făgăraș, Brașov și împrejurimi. Instructori atestați, mașini moderne și ore flexibile.",
      bookNow: "Programare online",
      callNow: "Sună la 0723 88 66 88",
      stat1Label: "Categoria",
      stat1Value: "B",
      stat2Label: "Instructori",
      stat2Value: "Atestați",
      stat3Label: "Mașini moderne",
      stat3Value: "Din anii 2024 și 2020",
    },
    marquee: ["Categoria B", "Cutie manuală", "Cutie automată", "Făgăraș - Brașov și împrejurimi", "Instructori atestați", "Programare online"],
    about: {
      eyebrow: "Despre noi",
      title: "O echipă locală, prietenoasă și serioasă",
      p1: "BIU BIU DRIVING – Școala ta de șoferi categoria B, cutie manuală și automată, în Făgăraș, Brașov și împrejurimi.",
      p2: "Lucrăm exclusiv cu cursanți pentru Categoria B și oferim servicii profesioniste, datorită instruirii personalizate și autoturismelor moderne din dotare.",
      bullets: [
        "Instructori autorizați ARR, cu experiență",
        "Mașini noi: Suzuki S-Cross 2024 & Toyota Corolla Hybrid 2020",
        "Program flexibil – ne potrivim cu programul tău",
        "Atmosferă relaxată, fără stres",
      ],
    },
    pricing: {
      eyebrow: "Prețuri transparente",
      title: "Alege pachetul potrivit pentru tine",
      subtitle: "Două pachete complete pentru permis Categoria B și servicii suplimentare. Fără costuri ascunse.",
      mainTitle: "Pachete complete",
      extrasTitle: "Servicii suplimentare",
      extrasSubtitle: "Ai nevoie de mai multe ore sau de mașina pentru ziua examenului? Le poți adăuga oricând.",
      manual: {
        badge: "Cea mai populară",
        title: "Cutie manuală",
        car: "Suzuki S-Cross 2024",
        price: "2500",
        oldPrice: "2750",
        currency: "LEI",
        features: [
          "Curs complet pentru Categoria B",
          "Include 24 ore de legislație rutieră și 30 de ore de conducere",
          "Mașină modernă, sigură",
          "Ore practice flexibile",
          "Sesiuni de pregătire pentru examen",
          "Asistență la dosar",
          "Plată și în două rate",
        ],
        cta: "Vreau cutie manuală",
      },
      automatic: {
        badge: "Confort sporit",
        title: "Cutie automată",
        car: "Toyota Corolla Hybrid 2020",
        price: "2700",
        oldPrice: "3000",
        currency: "LEI",
        features: [
          "Curs complet pentru Categoria B",
          "Include 24 ore de legislație rutieră și 30 de ore de conducere",
          "Mașină hybrid – condus relaxat",
          "Fără ambreiaj, fără stres",
          "Ideal pentru oraș și începători",
          "Asistență la dosar",
          "Plată și în două rate",
        ],
        cta: "Vreau cutie automată",
      },
      extras: [
        {
          code: "extra_driving",
          title: "6 ore suplimentare de conducere",
          desc: "Pachet de 6 ore suplimentare pentru a câștiga încredere la volan.",
          price: "750",
          currency: "LEI",
          cta: "Adaugă la programare",
        },
        {
          code: "extra_legislation",
          title: "2 ore suplimentare legislație rutieră",
          desc: "Recapitulare intensivă pentru proba de sală și testul auto.",
          price: "300",
          currency: "LEI",
          cta: "Adaugă la programare",
        },
        {
          code: "exam_car",
          title: "Mașina pentru ziua de examen",
          desc: "Punem la dispoziție mașina pentru proba de traseu la examen.",
          price: "250",
          currency: "LEI",
          cta: "Rezervă mașina",
        },
      ],
    },
    docs: {
      eyebrow: "Acte necesare",
      title: "Documente pentru înscriere",
      subtitle: "Adună aceste acte și ești gata să începi cursurile. Te ajutăm cu tot dosarul.",
      items: [
        { t: "Carte de identitate", d: "Original + copie. Trebuie să fie valabilă." },
        { t: "Fișă medicală auto", d: "De la o unitate medicală autorizată (vezi lista mai jos)." },
        { t: "Aviz psihologic", d: "Eliberat de un cabinet psihologic autorizat." },
        {
          t: "Cazier judiciar",
          d: "În original, eliberat recent.",
          externalUrl: "CAZIER_BRASOV_URL",
          externalLabel: "Click aici să vezi de unde îl poți lua din județul Brașov și programul",
        },
        {
          t: "Cerere de înscriere",
          d: "Formular completat la sediul școlii.",
          link: "ENROLLMENT_FORM_PDF",
          linkLabel: "Vezi și descarcă cererea PDF",
        },
        {
          t: "Lista unităților medicale",
          d: "Județul Brașov — unități autorizate de Direcția de Sănătate Publică Brașov pentru eliberarea Fișei medicale.",
          link: "MEDICAL_LIST_PDF",
          linkLabel: "Vezi și descarcă PDF",
        },
      ],
      note: "Ai nevoie de ajutor? Sună-ne și te ghidăm prin tot procesul.",
    },
    testimonials: {
      eyebrow: "Testimoniale",
      title: "Părerile cursanților noștri",
      subtitle: "Aici vor apărea în curând experiențele celor care au luat permisul cu BIU BIU DRIVING.",
      empty: "Fii primul care lasă o recenzie despre BIU BIU DRIVING.",
      cta: "Programează-te acum",
      addBtn: "Adaugă o recenzie",
      form: {
        title: "Împărtășește experiența ta",
        subtitle: "După aprobare, recenzia ta va apărea pe site și îi va ajuta pe alți cursanți să aleagă cu încredere.",
        name: "Numele tău",
        rating: "Nota (1-5 stele)",
        text: "Recenzia ta",
        textPlaceholder: "Scrie despre experiența ta la BIU BIU DRIVING...",
        photos: "Fotografii (opțional, max 3, până în 5MB fiecare)",
        photosHint: "Poți adăuga poze cu tine, cu mașina, sau cu permisul obținut.",
        submit: "Trimite recenzia",
        submitting: "Se trimite...",
        successTitle: "Mulțumim!",
        successMsg: "Recenzia ta a fost trimisă cu succes. După aprobare va apărea pe site.",
        errorMsg: "A apărut o eroare. Te rugăm să încerci din nou.",
        cancel: "Anulează",
      },
    },
    faq: {
      eyebrow: "Întrebări frecvente - FAQ",
      title: "Tot ce trebuie să știi despre permisul Categoria B",
      subtitle: "Răspunsuri clare, bazate pe legislația în vigoare, la cele mai importante întrebări despre școala de șoferi, examen și permis.",
      cardTitle: "Nu ai găsit răspuns?",
      cardDesc: "Sună-ne direct și te ajutăm cu orice nelămurire — gratuit, fără obligații.",
    },
    gallery: {
      eyebrow: "Galerie",
      title: "Mașinile cu care vei învăța",
      subtitle: "Autoturisme moderne, sigure și confortabile.",
    },
    contact: {
      eyebrow: "Contact & Programare",
      title: "Hai să ne cunoaștem",
      subtitle: "Completează formularul sau sună-ne direct. Răspundem rapid.",
      labels: {
        name: "Nume complet",
        phone: "Telefon",
        email: "Email",
        transmission: "Serviciu dorit",
        services: {
          manual: "Pachet cutie manuală - 2500 LEI",
          automatic: "Pachet cutie automată - 2700 LEI",
          extra_driving: "6 ore suplimentare de conducere - 750 LEI",
          extra_legislation: "2 ore suplimentare legislație - 300 LEI",
          exam_car: "Mașina pentru ziua de examen - 250 LEI",
        },
        date: "Data preferată",
        message: "Mesaj (opțional)",
        submit: "Trimite programarea",
        submitting: "Se trimite...",
      },
      info: {
        phone: "Telefon",
        email: "Email",
        address: "Adresă",
        addressValue: "Hârseni - Sebeș nr. 94, Mândra, jud. Brașov",
        hours: "Program",
        hoursValue: "Luni - Sâmbătă: 09:00 - 19:00",
      },
      success: "Mulțumim! Mesajul tău a fost trimis. Te contactăm în curând.",
      error: "A apărut o eroare. Te rugăm să încerci din nou sau să ne suni direct.",
    },
    footer: {
      tagline: "Școala ta de șoferi din Țara Făgărașului, Brașov",
      quickLinks: "Linkuri rapide",
      contactTitle: "Contact",
      rights: "Toate drepturile rezervate.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      pricing: "Pricing",
      docs: "Documents",
      gallery: "Gallery",
      faq: "FAQ",
      faqFull: "Frequently asked questions - FAQ",
      contact: "Contact",
      book: "Book now",
      callNow: "Call now",
    },
    hero: {
      eyebrow: "Driving School · Category B",
      title1: "Learn to drive",
      title2: "calmly and safely",
      subtitle: "BIU BIU DRIVING – Your Category B driving school, manual and automatic transmission, in Făgăraș, Brașov and surrounding areas. Certified instructors, modern cars and flexible hours.",
      bookNow: "Book online",
      callNow: "Call 0723 88 66 88",
      stat1Label: "Category",
      stat1Value: "B",
      stat2Label: "Instructors",
      stat2Value: "Certified",
      stat3Label: "Modern cars",
      stat3Value: "Since 2024 & 2020",
    },
    marquee: ["Category B", "Manual transmission", "Automatic transmission", "Făgăraș - Brașov & surroundings", "Certified instructors", "Online booking"],
    about: {
      eyebrow: "About us",
      title: "A local, friendly and serious team",
      p1: "BIU BIU DRIVING – Your Category B driving school, manual and automatic transmission, in Făgăraș, Brașov and surrounding areas.",
      p2: "We work exclusively with Category B students and offer professional services, thanks to personalized instruction and our modern fleet.",
      bullets: [
        "ARR-licensed, experienced instructors",
        "New cars: Suzuki S-Cross 2024 & Toyota Corolla Hybrid 2020",
        "Flexible schedule – we adapt to your time",
        "Relaxed, stress-free atmosphere",
      ],
    },
    pricing: {
      eyebrow: "Transparent pricing",
      title: "Pick the package that fits you",
      subtitle: "Two complete packages for the Category B license plus optional extras. No hidden costs.",
      mainTitle: "Complete packages",
      extrasTitle: "Add-on services",
      extrasSubtitle: "Need extra hours or the exam-day car? You can add any of these anytime.",
      manual: {
        badge: "Most popular",
        title: "Manual transmission",
        car: "Suzuki S-Cross 2024",
        price: "2500",
        oldPrice: "2750",
        currency: "LEI",
        features: [
          "Complete Category B course",
          "Includes 24 hours of road law and 30 hours of driving",
          "Modern, safe vehicle",
          "Flexible practical hours",
          "Exam preparation sessions",
          "File assistance",
          "Pay in two installments",
        ],
        cta: "Choose manual",
      },
      automatic: {
        badge: "Extra comfort",
        title: "Automatic transmission",
        car: "Toyota Corolla Hybrid 2020",
        price: "2700",
        oldPrice: "3000",
        currency: "LEI",
        features: [
          "Complete Category B course",
          "Includes 24 hours of road law and 30 hours of driving",
          "Hybrid car – relaxed driving",
          "No clutch, no stress",
          "Perfect for city & beginners",
          "File assistance",
          "Pay in two installments",
        ],
        cta: "Choose automatic",
      },
      extras: [
        {
          code: "extra_driving",
          title: "6 extra driving hours",
          desc: "Six extra practical hours to build confidence behind the wheel.",
          price: "750",
          currency: "LEI",
          cta: "Add to booking",
        },
        {
          code: "extra_legislation",
          title: "2 extra road law hours",
          desc: "Intensive recap for the theory exam and classroom test.",
          price: "300",
          currency: "LEI",
          cta: "Add to booking",
        },
        {
          code: "exam_car",
          title: "Exam-day car",
          desc: "We provide the car for your practical exam route.",
          price: "250",
          currency: "LEI",
          cta: "Book the car",
        },
      ],
    },
    docs: {
      eyebrow: "Required documents",
      title: "Documents for enrollment",
      subtitle: "Gather these documents and you're ready to start. We help you with the whole file.",
      items: [
        { t: "ID card", d: "Original + copy. Must be valid." },
        { t: "Medical certificate", d: "From an authorized medical unit (see list below)." },
        { t: "Psychological exam", d: "Issued by an authorized psychologist." },
        {
          t: "Criminal record",
          d: "Original, recently issued.",
          externalUrl: "CAZIER_BRASOV_URL",
          externalLabel: "Click here to see where to get it in Brașov county and the schedule",
        },
        {
          t: "Enrollment form",
          d: "Form filled in at the school's office.",
          link: "ENROLLMENT_FORM_PDF",
          linkLabel: "View & download the form PDF",
        },
        {
          t: "List of medical units",
          d: "Brașov county — medical units authorized by the Brașov Public Health Department to issue the medical certificate.",
          link: "MEDICAL_LIST_PDF",
          linkLabel: "View & download PDF",
        },
      ],
      note: "Need help? Call us and we'll guide you through the whole process.",
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "What our students say",
      subtitle: "Stories from those who got their license with BIU BIU DRIVING will appear here soon.",
      empty: "Be the first to leave a review for BIU BIU DRIVING.",
      cta: "Book now",
      addBtn: "Add a review",
      form: {
        title: "Share your experience",
        subtitle: "After approval, your review will appear on the site and help other students choose with confidence.",
        name: "Your name",
        rating: "Rating (1-5 stars)",
        text: "Your review",
        textPlaceholder: "Tell us about your experience at BIU BIU DRIVING...",
        photos: "Photos (optional, max 3, up to 5MB each)",
        photosHint: "You can attach photos of yourself, the car, or your obtained licence.",
        submit: "Send review",
        submitting: "Sending...",
        successTitle: "Thank you!",
        successMsg: "Your review has been submitted. After approval it will appear on the site.",
        errorMsg: "An error occurred. Please try again.",
        cancel: "Cancel",
      },
    },
    faq: {
      eyebrow: "Frequently asked questions - FAQ",
      title: "Everything you need to know about the Category B license",
      subtitle: "Clear answers, based on current legislation, to the most important questions about driving school, the exam and the license.",
      cardTitle: "Didn't find your answer?",
      cardDesc: "Call us directly — we'll help with any question, free, no obligations.",
    },
    gallery: {
      eyebrow: "Gallery",
      title: "The cars you'll learn with",
      subtitle: "Modern, safe and comfortable vehicles.",
    },
    contact: {
      eyebrow: "Contact & Booking",
      title: "Let's get in touch",
      subtitle: "Fill the form or call us directly. We respond quickly.",
      labels: {
        name: "Full name",
        phone: "Phone",
        email: "Email",
        transmission: "Service",
        services: {
          manual: "Manual transmission package - 2500 LEI",
          automatic: "Automatic transmission package - 2700 LEI",
          extra_driving: "6 extra driving hours - 750 LEI",
          extra_legislation: "2 extra road law hours - 300 LEI",
          exam_car: "Exam-day car - 250 LEI",
        },
        date: "Preferred date",
        message: "Message (optional)",
        submit: "Send booking",
        submitting: "Sending...",
      },
      info: {
        phone: "Phone",
        email: "Email",
        address: "Address",
        addressValue: "Hârseni - Sebeș no. 94, Mândra, Brașov county",
        hours: "Hours",
        hoursValue: "Mon - Sat: 09:00 - 19:00",
      },
      success: "Thank you! Your message was sent. We'll contact you soon.",
      error: "Something went wrong. Please try again or call us directly.",
    },
    footer: {
      tagline: "Your driving school in the Făgăraș area, Brașov",
      quickLinks: "Quick links",
      contactTitle: "Contact",
      rights: "All rights reserved.",
    },
  },
};

const LangContext = createContext({ lang: "ro", setLang: () => {}, t: translations.ro });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "ro";
    return localStorage.getItem("bbd_lang") || "ro";
  });

  useEffect(() => {
    localStorage.setItem("bbd_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] }),
    [lang]
  );

  return (
    <LangContext.Provider value={value}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
